import ScalarIconInfo_vue_vue_type_script_setup_true_lang_default from "./ScalarIconInfo.vue.script.js";
//#region src/components/ScalarIconInfo.vue
var ScalarIconInfo_default = ScalarIconInfo_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconInfo_default as default };

//# sourceMappingURL=ScalarIconInfo.js.map